import _isIterable from "./is-iterable";
var exports = {};
var isIterable = _isIterable;

exports = function (value) {
  if (!isIterable(value)) throw new TypeError(value + " is not iterable");
  return value;
};

export default exports;